import { required } from 'vuelidate/lib/validators';

const validations = {
  brand: {
    title: {
      required,
    },
    topBrandItems: {
      required,
    },
  },
};

export default validations;
